import { render, staticRenderFns } from "./PlanModal.vue?vue&type=template&id=63421c8a&scoped=true"
import script from "./PlanModal.vue?vue&type=script&lang=ts"
export * from "./PlanModal.vue?vue&type=script&lang=ts"
import style0 from "./PlanModal.vue?vue&type=style&index=0&id=63421c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63421c8a",
  null
  
)

export default component.exports